export default {
  MOVIE_DB_API_KEY: '8ba66aa8a238bc7726e6c4f94ffd3660',
  MOVIE_DB_API_ROOT: 'https://api.themoviedb.org/3',
};
